<template>
  <!-- Comments: browse or comment, a two-part switch centred in the preview header (founder 19.10.2026, spec Rev. 4). -->
  <div class="preview-mode-bar" role="toolbar" :aria-label="$t('webmag.comments.title')">
    <button
      type="button" data-test="mode-browse" :class="['preview-mode', { active: !commentMode }]"
      :aria-pressed="String(!commentMode)" :title="$t('webmag.comments.browse')" :aria-label="$t('webmag.comments.browse')"
      @click="$emit('update:commentMode', false)"
    >
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true">
        <path d="M4 3l7 17 2.5-7.5L21 10z" />
      </svg>
      <span class="preview-mode-label">{{ $t('webmag.comments.browse') }}</span>
    </button>
    <button
      type="button" data-test="mode-comment" :class="['preview-mode', { active: commentMode }]"
      :aria-pressed="String(commentMode)" :title="$t('webmag.comments.modeHint')" :aria-label="$t('webmag.comments.mode')"
      @click="$emit('update:commentMode', true)"
    >
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true">
        <path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1.1-4.6A8 8 0 1 1 21 12z" />
        <path d="M8.5 12h.01M12 12h.01M15.5 12h.01" stroke-linecap="round" />
      </svg>
      <span class="preview-mode-label">{{ $t('webmag.comments.mode') }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'PreviewModeBar',
  props: {
    commentMode: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
/* On the dark preview header: a quiet track, the active part white. */
.preview-mode-bar {
  display: inline-flex;
  gap: 2px;
  padding: 3px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
}

.preview-mode {
  display: inline-flex;
  gap: 6px;
  align-items: center;
  height: 30px;
  padding: 0 12px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #d1d5db;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}

.preview-mode:hover {
  color: #fff;
}

.preview-mode.active {
  background: #fff;
  color: #111827;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

/* Narrow windows: icons only, so the switch never runs over the page name (small fixes 19.10.2026). */
@media (max-width: 1100px) {
  .preview-mode-label {
    display: none;
  }
}
</style>
